import React from 'react';
import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

const StyledTablePagination = styled(TablePagination)`
  &&{
      font-size: 13px !important;

      .MuiTypography-root {
          font-size: 13px !important;
      }
      
      .MuiToolbar-root {
        min-height: 40px !important;
        padding: 0 !important;
      }
      .MuiIconButton-root{
      font-size: 1.2857142857142856rem;
      }
      .MuiSelect-select{
      font-size: 13px !important;
      }
      .MuiTablePagination-selectIcon{
      font-size: 1.2857142857142856rem;
      top: calc(50% - 12px);
      }
      .MuiTablePagination-selectLabel,
      .MuiTablePagination-displayedRows {
          font-size: 13px !important;
          margin: 0 !important;
         letter-spacing: 0 !important;

      }
      
  }
`;

const StyledTablePaginationActions = styled.div`
  &&{
     flex-shrink: 0;
     max-height: 40px !important;
     overflow: hidden;
     
     .MuiButtonBase-root {
        padding: 10px 12px;
     }
  }
`;

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <StyledTablePaginationActions>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </StyledTablePaginationActions>
  );
}

const BaseTablePagination = ({ total, perPage, page, handleSetPage, handleSetPerPage }) => {
  return <StyledTablePagination
    rowsPerPageOptions={[25, 50, 75, 100]}
    component="div"
    count={total}
    ActionsComponent={TablePaginationActions}
    rowsPerPage={perPage}
    page={page - 1}
    backIconButtonProps={{
      'aria-label': 'Previous Page',
    }}
    nextIconButtonProps={{
      'aria-label': 'Next Page',
    }}
    onPageChange={handleSetPage}
    onRowsPerPageChange={handleSetPerPage}
  />
}

export default BaseTablePagination;